import '.a{display:flex;}.ssr-plugin'
import '.i{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.ap{gap:0.5rem;}.ssr-plugin'
import '.av{cursor:pointer;}.ssr-plugin'
import '.gc{padding:0.75rem;}.ssr-plugin'
import '.ae{border-radius:1.25rem;}.ssr-plugin'
import '.aq{border:var(--border-subtle);}.ssr-plugin'
import '.af{background-color:var(--palette-white);}.ssr-plugin'
import '.dq{transition:background-color 0.2s ease;}.ssr-plugin'
import '.cu{width:2.5rem;}.ssr-plugin'
import '.cv{height:2.5rem;}.ssr-plugin'
import '.jx{color:var(--palette-blue-700);}.ssr-plugin'
import '.jy{font-size:0.9rem;}.ssr-plugin'
import '.a7{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="a i b c ap av gc ae aq af dq"
        style={{
          '&:hover': {
            backgroundColor: 'var(--palette-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="cu cv a c i jx"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="jy jx a7"
        >
          {label}
        </span>
      </styled.button>
    )
}